import { FontTShirtSize } from '@modules/common/models'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Popover from '@material-ui/core/Popover'
import React from 'react'
import styled from 'styled-components'
import * as css from './StandardSearchView.css'
import { TableViewColumnDefinition } from '@components/UI-Components/StandardTableView/models/TableViewColumnDefinition'
import { useTranslation } from 'react-i18next'
import { Typography } from '@material-ui/core'
import { StandardTableView } from '../StandardTableView'

const PADDING = 20
const ACTION_ITEM_HELGHT = 20

interface IStandardSearchViewProps {
  headerData: Array<any>
  isUpperCase: boolean
  onHeaderDataSelect: (event: any) => void
  selectedHeaderId: string
  handleClose: () => void
  anchorEl: any
  columnDef: Array<TableViewColumnDefinition>
  processedData: Array<any>
  tableRowHeight: number
  headerHeight: number
  searchContainerHeight: number
  searchContainerWidth: number
  allowMultiSelect?: boolean
  setSelectedData?: any
  maxSelectionLimit?: number
  isActionAllowed?: boolean
  handleSubmit?: any
  isActionInProcess?: boolean
  isActionDisabled?: boolean
  showCountDetails?: boolean
  canSelectAll?: boolean
  selectedRows?: any
  disabledRows?: any[]
  showAllFilter?: boolean
}

const StyledSearchDiv = styled.div<{ height: number; width: number }>`
  height: ${props => props.height + 'px'};
  width: ${props => props.width + 'px'};
  box-shadow: 5px 15px 30px 0 rgba(132, 132, 132, 0.25);
  background-color: #ffffff;
  padding: ${PADDING + 'px'};
  overflow: hidden;
`

const StyledTableContainer = styled.div<{ height: number }>`
  height: ${props => props.height - 2 * PADDING + 'px'};
`
const StyledActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const styleText = {
  font: 'var(--typography-body4)',
  letterSpacing: 'var(--label-typography-letter-spacing)',
  color: 'black'
}

export const StandardSearchView: React.FunctionComponent<IStandardSearchViewProps> = ({
  headerData,
  onHeaderDataSelect,
  selectedHeaderId,
  handleClose,
  anchorEl,
  columnDef,
  processedData,
  tableRowHeight,
  headerHeight,
  searchContainerHeight,
  searchContainerWidth,
  allowMultiSelect,
  setSelectedData,
  maxSelectionLimit,
  isActionAllowed,
  handleSubmit,
  isActionInProcess,
  isActionDisabled,
  showCountDetails,
  canSelectAll,
  selectedRows,
  disabledRows,
  showAllFilter
}) => {
  const { t } = useTranslation()
  const open = Boolean(anchorEl)
  const id = open ? 'search-popover' : undefined

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
    >
      <StyledSearchDiv height={searchContainerHeight} width={searchContainerWidth}>
        <StyledTableContainer
          height={searchContainerHeight - (isActionAllowed ? ACTION_ITEM_HELGHT : 0)}
        >
          <div style={{ height: `calc(100% - ${headerHeight - 30}px)` }}>
            <StandardTableView
              headerData={headerData}
              selectedHeaderId={selectedHeaderId}
              onHeaderDataSelect={onHeaderDataSelect}
              colDef={columnDef}
              overScanCount={13}
              data={processedData}
              headerHeight={headerHeight}
              rowHeight={tableRowHeight}
              fieldNameToJump={'name'}
              hideHeader={true}
              showSearch={true}
              tableCellFontSize={FontTShirtSize.sm}
              allowMultiSelect={allowMultiSelect}
              setSelectedData={setSelectedData}
              maxSelectionLimit={maxSelectionLimit}
              showCountDetails={showCountDetails}
              canSelectAll={canSelectAll}
              selectedRows={selectedRows}
              disabledRows={disabledRows}
              showAllFilter={showAllFilter}
            />
          </div>

          <div className={css['divider']} />
        </StyledTableContainer>

        {isActionAllowed ? (
          <StyledActionContainer>
            <Button
              onClick={handleSubmit}
              disabled={isActionInProcess || isActionDisabled}
            >
              <Typography style={styleText}>
                {t('common.label.apply', 'Apply')}
              </Typography>
              {isActionInProcess && (
                <CircularProgress className={css.buttonProgress} size={24} />
              )}
            </Button>
            <Button onClick={handleClose}>
              <Typography style={styleText}>
                {t('common.label.cancel', 'Cancel')}
              </Typography>
            </Button>
          </StyledActionContainer>
        ) : null}
      </StyledSearchDiv>
    </Popover>
  )
}
